import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import * as R from 'ramda'

import Cpu from 'components/form/notebookCpu/index'
import { createNamedReducer } from 'helpers/ReducerUtil'
import { createNamedAction } from 'helpers/ActionUtil'
import { notebookValueReducer, createUiReducer } from './reducer'
import injectReducers from 'helpers/injectReducers'
import getSelectors from './selectors'
import {
  togglePopup,
  getUiActions,
  updateConfigSelection,
  updateConfigSource,
  addConfig,
  deletePart,
  updateCurConfig,
  updateConfigModelName,
} from './actions'
import {
  getPath,
  getUiPath,
  combinePath
} from 'containers/Form/util'

const withReducer = (path, id) => {
  const valuePath = getPath(path, id)
  const uiPath = getUiPath(id)
  const valueReducer = createNamedReducer(valuePath, notebookValueReducer)
  const uiReducer = createUiReducer(uiPath)

  return injectReducers({
    [valuePath]: valueReducer,
    [uiPath]: uiReducer,
  })
}

const withConnect = (path, id) => {
  const combinedPath = combinePath(path, id)
  const valuePath = getPath(path, id)
  const uiPath = getUiPath(id)
  const addConfigAction = createNamedAction(valuePath, addConfig)
  const updateConfigModelNameAction = createNamedAction(valuePath, updateConfigModelName)
  const deletePartAction = createNamedAction(valuePath, deletePart)
  const togglePopupAction = createNamedAction(uiPath, togglePopup)
  const updateConfigAction = createNamedAction(uiPath, updateConfigSelection)
  const updateConfigSourceAction = createNamedAction(uiPath, updateConfigSource)
  const updateCurConfigAction = createNamedAction(uiPath, updateCurConfig)

  const {
    filteredSourcesSelector,
    configSelectionSelector,
    configSourceSelector,
    togglePopupSelector,
    archSelector,
    brandSelector,
    classSelector,
    notebookConfigsSelector,
    curConfigSelector,
    filterPairsSelector,
    segmentSelector
  } = getSelectors(combinedPath, uiPath)

  const {
    toggleArch,
    toggleBrand,
    toggleClass,
    initFilters,
    refreshFilters,
  } = getUiActions(uiPath)

  const mapStateToProps = state => {
    return {
      sources: filteredSourcesSelector(state),
      values: notebookConfigsSelector(state),
      configSelection: configSelectionSelector(state),
      configSource: configSourceSelector(state),
      togglePopup: togglePopupSelector(state),
      archFilter: archSelector(state),
      brandFilter: brandSelector(state),
      classFilter: classSelector(state),
      curConfig: curConfigSelector(state),
      filterPairs: filterPairsSelector(state),
      segment: segmentSelector(state)
    }
  }

  const mapDispatchToProps = dispatch => {
    return {
      onTogglePopup: () => {
        dispatch(togglePopupAction())
      },
      onArchChange: (index, value) => {
        dispatch(toggleArch(index, value))
      },
      onBrandChange: (index, value) => {
        dispatch(toggleBrand(index, value))
      },
      onClassChange: (index, value) => {
        dispatch(toggleClass(index, value))
      },
      onUpdateConfig: (value) => {
        dispatch(updateConfigAction(value))
      },
      onUpdateConfigSource: (value) => {
        dispatch(updateConfigSourceAction(value))
      },
      onUpdateCurConfig: (value) => {
        dispatch(updateCurConfigAction(value))
      },
      onAddPart: (value) => {
        dispatch(addConfigAction(value))
      },
      onModelNameChange: (index, value) => {
        dispatch(updateConfigModelNameAction(index, value))
      },
      onDeletePart: (index) => {
        dispatch(deletePartAction(index))
      },
      onRefreshFilter: () => {
        dispatch(refreshFilters())
      },
      initFilters: (filters) => {
        dispatch(initFilters(filters)())
      }
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)
}

export { default as Cpu } from 'components/form/notebookCpu/index'
export {
  withConnect,
  withReducer
}

export default R.curry((path, id) => R.compose(
  withReducer(path, id),
  withConnect(path, id)
)(Cpu))
